import { useState, useEffect } from 'react';
import { words as arabic } from './ar';
import { words as english } from './en';
import { store } from 'tools/store';


let useTranslation = () => {
  var local = store.getState().global.language;

  let [translation, setTranslation] = useState(english);
  useEffect(() => {
    // console.log("=-=-=-", local)
    if (local === 'en' || local === undefined) {
      setTranslation(english);
    } else {
      setTranslation(arabic);
    }
  }, [local]);

  return translation;
};

export default useTranslation;
